import { Box, Modal } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import Logo from "../../../assets/olinfull.png";
import { Link } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalInfoOutlet = ({ open, setOpen, data }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            overflowY: "auto",
            overflowX: "wrap",
            maxHeight: "90vh",
            padding: 0,
          }}
          className="text-left w-[85%] lg:w-[60%] text-[12px]"
        >
          <div className="flex justify-between align-center p-8 pb-0">
            <div className="flex items-center">
              <img
                src={data?.company?.logo === "" ? Logo : data?.company?.logo}
                alt=""
                className="w-[64px] h-[64px] object-contain border-2 rounded-full mr-3"
              />
              <p className="text-xl font-semibold">
                {data?.company && data?.company !== undefined
                  ? data?.company?.name
                  : data?.company?.name}
              </p>
            </div>
            <RxCross2
              className="inline-block cursor-pointer h-full text-[24px]"
              onClick={handleClose}
            />
          </div>
          <hr className="my-4" />
          <div className="rounded-md shadow-md w-full p-8 pt-0">
            <div className="block overflow-x-auto w-full rounded-md">
              {data?.company && data?.company !== undefined ? (
                <table class="min-w-full border-collapse">
                  <tbody>
                    <tr>
                      <td class="py-2 w-1/4">Nomor Izin Apotek</td>
                      <td class="py-2 ">:</td>
                      <td class="px-4 py-2 ">{data?.company.permission_id}</td>
                    </tr>
                    <tr>
                      <td class="py-2 ">Alamat Apotek</td>
                      <td class="py-2 ">:</td>
                      <td class="px-4 py-2 ">{data?.company.address}</td>
                    </tr>
                    <tr>
                      <td class="py-2 ">Lokasi Global</td>
                      <td class="py-2 ">:</td>
                      <td class="px-4 py-2 text-blue-500 hover:underline">
                        {data?.url_latlong === "" ||
                        data?.url_latlong === "-" ? (
                          <p className="truncate">Lihat Lokasi</p>
                        ) : (
                          <Link
                            to={data?.company.url_latlong}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Lihat Lokasi
                          </Link>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td class="py-2 ">Lokasi Apotek</td>
                      <td class="py-2 ">:</td>
                      <td class="px-4 py-2 ">{data?.company.city}</td>
                    </tr>
                    <tr>
                      <td class="py-2 ">Apoteker</td>
                      <td class="py-2 ">:</td>
                      <td class="px-4 py-2 ">{data?.company.fullname}</td>
                    </tr>
                    <tr>
                      <td class="py-2 ">SIPA</td>
                      <td class="py-2 ">:</td>
                      <td class="px-4 py-2 ">{data?.company.sipa_id}</td>
                    </tr>
                    <tr>
                      <td class="py-2 ">Jadwal Praktik</td>
                      <td class="py-2 ">:</td>
                      <td class="px-4 py-2 ">08 : 00 - 18 : 00</td>
                    </tr>
                  </tbody>
                </table>
              ) : null}
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ModalInfoOutlet;
